import React from 'react';

import { reduxForm } from 'redux-form';

import PersonalDetails from 'components/landlord_app/applications/components/PersonalDetails';
import Header from 'components/shared/Header';

const FORM_NAME = 'edit_lead_basic_form';

let editLeadBasicForm = class extends React.Component {
  render() {
    const { handleSubmit } = this.props;
    return (
      <form onSubmit={handleSubmit}>
        <div className="row" style={{ marginBottom: '10px', marginTop: '20px' }}>
          <Header name="Lead Information" />
        </div>

        <PersonalDetails disableBirthdayAndSalary hideSalary hideSIN />
      </form>
    );
  }
};

editLeadBasicForm = reduxForm({
  form: FORM_NAME,
  destroyOnUnmount: true,
  forceUnregisterOnUnmount: true,
})(editLeadBasicForm);

export default editLeadBasicForm;
